<svg width="679" height="500" viewBox="0 0 679 500" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="623.127" cy="307.46" r="40.6209" transform="rotate(29.5738 623.127 307.46)" fill="url(#paint0_linear_249_107)"/>
<circle cx="535.059" cy="363.058" r="20.5818" transform="rotate(29.5738 535.059 363.058)" fill="url(#paint1_linear_249_107)"/>
<circle cx="250.338" cy="250.339" r="248.971" transform="rotate(-179.864 250.338 250.339)" fill="url(#paint2_linear_249_107)"/>
<defs>
<linearGradient id="paint0_linear_249_107" x1="623.127" y1="348.081" x2="517.79" y2="192.739" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint1_linear_249_107" x1="535.059" y1="383.64" x2="481.687" y2="304.932" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint2_linear_249_107" x1="91.6675" y1="78.7677" x2="588.75" y2="609.391" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
</defs>
</svg>
